import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleHalf = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.75 12a9.25 9.25 0 0 1 18.5 0zM12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25",
		clipRule: "evenodd"
	})
});
export default SvgCircleHalf;
